// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-module_loading_1zmTT"};